import $ from 'jquery';

export class UserService {
    constructor(component) {
        this.component = component;
    }
}